import { ISLEntryPostBody } from "../schemas/SLEntryPostBody";
import { IAttachment } from "../schemas/SLAttachment";
import { ISLAttachmentPostBody, ISlEntryAttachmentActionRequest } from "../schemas/SLAttachmentPostBody";
import { ISLEntryGridItem } from "../schemas/SLEntryGridSchemas";
import { ISlEntryActionRequest, ISlEntryPosterActionRequest } from "../schemas/SlEntryActionRequest";
import { ISLAdditionalPostersRequest } from "../schemas/SLAdditionalPostersRequest";
import SLEntryLineItemsFactory from "./SLEntryLineItemsFactory";

export interface ISLEntryFactoryProps {
  slEntry: ISLEntry;
}

export interface ISLEntry {
  // header values
  companyCode: string;
  invoiceDate: Date | "";
  postingDate: Date | "";
  translationDate: Date | "";
  reference: string;
  documentType: string;
  credit: string;
  debit: string;
  amount: string;
  currency: string;
  headerText: string;
  purpose: string;
  lineItemsList: string[][];
  newUserComment: string;
  additionalPoster: string;
  attachmentsList: IAttachment[];
  rowVer: ArrayBuffer;
}

export interface ISLCreateHeader {
  companyCode: any;
  reference: any;
  currencyCode: any;
  credit: any;
  debit: any;
  totalAmount: any;
  invoiceDate: any;
  translationDate: any;
  postingDate: any;
  documentType: any;
  purpose: any;
  description: any;
  rowVer: ArrayBuffer | null;
}

export type PathActions =
  | ISlEntryActionRequest
  | ISLAdditionalPostersRequest
  | ISlEntryPosterActionRequest
  | ISlEntryAttachmentActionRequest;

export class SLEntryFactory {
  private lineItemsFactory = new SLEntryLineItemsFactory();

  public getSLEntryPostBody(slEntry: ISLEntry, slEntryId: number): ISLEntryPostBody {
    //const invoiceDate = slEntry.invoiceDate && slEntry.invoiceDate.toISOString();\const invoiceDate = slEntry.invoiceDate
    const invoiceDate = slEntry.invoiceDate
      ? `${slEntry.invoiceDate.getFullYear()}-${String(slEntry.invoiceDate.getMonth() + 1).padStart(2, "0")}-${String(
          slEntry.invoiceDate.getDate()
        ).padStart(2, "0")}T00:00:00`
      : slEntry.invoiceDate;

    //const postingDate = slEntry.postingDate && slEntry.postingDate.toISOString();

    const postingDate = slEntry.postingDate
      ? `${slEntry.postingDate.getFullYear()}-${String(slEntry.postingDate.getMonth() + 1).padStart(2, "0")}-${String(
          slEntry.postingDate.getDate()
        ).padStart(2, "0")}T00:00:00`
      : slEntry.postingDate;

    //const translationDate = slEntry.translationDate && slEntry.translationDate.toISOString();

    const translationDate = slEntry.translationDate
      ? `${slEntry.translationDate.getFullYear()}-${String(slEntry.translationDate.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(slEntry.translationDate.getDate()).padStart(2, "0")}T00:00:00`
      : slEntry.translationDate;

    const slLineItems = this.lineItemsFactory.lineItemListSanitationForPostEntry(slEntry.lineItemsList);
    const attachments = this.attachmentsSanitationForPostEntry(slEntry.attachmentsList);
    const companyCode = slEntry.companyCode.slice(0, 4);

    const headerPostBody: ISLEntryPostBody = {
      companyCode,
      invoiceDate,
      postingDate,
      translationDate,
      reference: slEntry.reference,
      documentType: slEntry.documentType,
      credit: slEntry.credit,
      debit: slEntry.debit,
      amount: slEntry.amount,
      currency: slEntry.currency,
      headerText: slEntry.headerText,
      purpose: slEntry.purpose,
      slLineItems,
      userComments: slEntry.newUserComment,
      attachments,
      rowVer: slEntry.rowVer,
      additionalPoster: slEntry.additionalPoster,
      slEntryId
    };
    return headerPostBody;
  }

  public attachmentsSanitationForPostEntry(list: IAttachment[]): ISLAttachmentPostBody[] {
    if (!list) {
      return [] as ISLAttachmentPostBody[];
    }
    const displayDate = new Date().toUTCString();
    const attachments = list.map(
      (element: IAttachment) =>
        ({
          blobName: element.blobName,
          fileName: element.fileName,
          fileSize: element.fileSize,
          uploadedOn: element.uploadedOn === "" || !element.uploadedOn ? displayDate : element.uploadedOn,
          url: element.url
        } as ISLAttachmentPostBody)
    );
    return attachments;
  }

  public mapEntryGridItemsToDetailsListItems(entryGridItems: ISLEntryGridItem[]): ISLEntryGridItem[] {
    if (!entryGridItems || entryGridItems.length < 1) {
      return [];
    }

    const items = entryGridItems.map((entryGridItem, key) => ({
      key,
      ...entryGridItem
    }));
    return items;
  }
}

export const slEntryFactory = new SLEntryFactory();
